module.exports = __webpack_public_path__ + "static/aside-swimming-1e2283152a80ab18acc338cede483b43.jpg";